import React from 'react';
import { useAtom } from 'jotai';
import { documentFilterState } from '@/recoil/atom';
import SortPopover from '@/components/Approval/@components/SortPopover';
import { documentSortList } from '@/components/Approval/Content/SearchDocument';

/** 회의록 목록 정렬(최근 등록순/업데이트순) — SubHeader('총 N건' 행) 우측에 배치 */
const DocumentSort = () => {
  const [filters, setFilters] = useAtom(documentFilterState);
  const handleSelected = (value: string) => {
    setFilters({ ...filters, sortType: value });
  };
  return (
    <SortPopover list={documentSortList} handleSelected={handleSelected} />
  );
};

export default DocumentSort;
